import { render, staticRenderFns } from "./chanpin.vue?vue&type=template&id=3a3309ae&scoped=true&"
import script from "./chanpin.vue?vue&type=script&lang=js&"
export * from "./chanpin.vue?vue&type=script&lang=js&"
import style0 from "./chanpin.vue?vue&type=style&index=0&id=3a3309ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3309ae",
  null
  
)

export default component.exports